import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdminEntityResponse, AdminEntityState } from 'components/admin/legal-entity/types/le';

const initialState: AdminEntityState = {
  adminEntities: null,
  isLoading: false,
  error: null
};

const adminEntitySlice = createSlice({
  name: 'admin-entities',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },

    hasError(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getAllAdminEntities(state, action: PayloadAction<AdminEntityResponse>) {
      state.isLoading = false;
      state.adminEntities = action.payload;
      state.error = null;
    },

    clearAdminEntities(state) {
      state.isLoading = false;
      state.adminEntities = null;
      state.error = null;
    }
  }
});

export const {
  startLoading,
  hasError,
  getAllAdminEntities,
  clearAdminEntities
} = adminEntitySlice.actions;

// Selectors
export const selectAdminEntities = (state: { adminEntity: AdminEntityState }) => state.adminEntity.adminEntities;
export const selectAdminEntitiesLoading = (state: { adminEntity: AdminEntityState }) => state.adminEntity.isLoading;
export const selectAdminEntitiesError = (state: { adminEntity: AdminEntityState }) => state.adminEntity.error;

export default adminEntitySlice.reducer;